module.exports = __webpack_public_path__ + "static/media/ezugi.3a8a2321.webp";